import {
  GET_REGRAS_AVALIACAO,
  GET_REGRAS_AVALIACAO_SUCCESS,
  ADD_REGRAS_AVALIACAO,
  ADD_REGRAS_AVALIACAO_SUCCESS,
  UPDATE_REGRAS_AVALIACAO,
  UPDATE_REGRAS_AVALIACAO_SUCCESS,
  DELETE_REGRAS_AVALIACAO,
  DELETE_REGRAS_AVALIACAO_SUCCESS,
  BUSCA_REGRAS_AVALIACAO_EDICAO,
  BUSCA_REGRAS_AVALIACAO_EDICAO_SUCESSO,
  NOVO_REGRAS_AVALIACAO,
  SHOW_MESSAGE,
  HIDE_MESSAGE,
  ON_SHOW_SUCCESS_MESSAGE,
  ON_SHOW_LOADER,
  ON_HIDE_LOADER,
  CANCELA_EDICAO,
  APLICA_FILTRO_REGRA_AVALIACAO
} from 'constants/ActionTypes';

const INIT_STATE = {
  loader: false,
  regrasAvaliacaoList: [],
  selectedRegrasAvaliacao: null,
  showMessageSuccess: false,
  showMessageError: false,
  alertMessage: '',
  edicao: false,
  textoFiltro: ''
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case APLICA_FILTRO_REGRA_AVALIACAO: {
      const texto = action.payload || '';
      return {
        ...state,
        textoFiltro: texto
      }
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        showMessageSuccess: false,
        showMessageError: false
      };
    }
    case SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessageSuccess: false,
        showMessageError: true,
        loader: false
      };
    }
    case ON_SHOW_SUCCESS_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessageSuccess: true,
        showMessageError: false,
        loader: false
      };
    }
    case GET_REGRAS_AVALIACAO: {
      return {
        ...state,
        loader: true,
      };
    }
    case GET_REGRAS_AVALIACAO_SUCCESS: {
      return {
        ...state,
        loader: false,
        regrasAvaliacaoList: action.payload,
      };
    }
    case ADD_REGRAS_AVALIACAO: {
      return {
        ...state,
        loader: true,
      };
    }
    case ADD_REGRAS_AVALIACAO_SUCCESS: {
      return {
        ...state,
        loader: false,
        regrasAvaliacaoList: [action.payload, ...state.regrasAvaliacaoList],
        edicao: false
      };
    }
    case UPDATE_REGRAS_AVALIACAO: {
      return {
        ...state,
        loader: true,
      };
    }
    case UPDATE_REGRAS_AVALIACAO_SUCCESS: {
      return {
        ...state,
        loader: false,
        regrasAvaliacaoList: state.regrasAvaliacaoList.map(item => item.id === action.payload.id ? action.payload : item),
        edicao: false
      };
    }
    case DELETE_REGRAS_AVALIACAO: {
      return {
        ...state,
        loader: true,
      };
    }
    case DELETE_REGRAS_AVALIACAO_SUCCESS: {
      return {
        ...state,
        loader: false,
        regrasAvaliacaoList: state.regrasAvaliacaoList.filter(item => item.id !== action.payload),
        edicao: false
      };
    }
    case BUSCA_REGRAS_AVALIACAO_EDICAO: {
      return {
        ...state,
        loader: true,
        edicao: true,
        selectedRegrasAvaliacao: null
      };
    }
    case BUSCA_REGRAS_AVALIACAO_EDICAO_SUCESSO: {
      return {
        ...state,
        loader: false,
        selectedRegrasAvaliacao: action.payload,
        edicao: true
      };
    }
    case NOVO_REGRAS_AVALIACAO: {
      return {
        ...state,
        selectedRegrasAvaliacao: null,
        edicao: true
      };
    }
    case CANCELA_EDICAO: {
      return {
        ...state,
        selectedRegrasAvaliacao: null,
        edicao: false
      };
    }
    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true
      };
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false
      };
    }
    default:
      return state;
  }
};
